<template>
    <div class="modal-goodslist" :style="goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">老人详情</div>
            </div>
            <div class="modal-body" :style="bodyStyle">

                <el-form :model="editForm" :rules="elderlyAllType.rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>基本信息</span>
                                </div>
                                
                                <el-col :span="18">
                                    <el-col :span="8" class="item">
                                    <el-form-item label="姓名" required prop="name" >
                                        <el-input v-model="editForm.name" disabled placeholder="请输入姓名"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="身份证号" required prop="idCard">
                                        <el-input v-model="editForm.idCard" disabled  maxlength="18" placeholder="请输入身份证号"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="手机号" required  prop="phone">
                                        <el-input v-model="editForm.phone" disabled  maxlength="11" placeholder="请输入手机号"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="婚姻状况"  prop="isMarriage">
                                        <el-select v-model="editForm.isMarriage" disabled  placeholder="请选择婚姻状况" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.maritalValue"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="民族"  prop="sysNation" required>
                                        <el-select v-model="editForm.sysNation" disabled  filterable placeholder="请选择民族" style="width:100%">
                                            <el-option
                                                    v-for="item in nationValue"
                                                    :key="item.id"
                                                    :label="item.nation"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="政治面貌" prop="politicsStatus">
                                        <el-select v-model="editForm.politicsStatus" disabled  placeholder="请选择政治面貌" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.politicalOutlook"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="文化程度" prop="education">
                                        <el-select v-model="editForm.education"  disabled  placeholder="请选择文化程度" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.education"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="地区" required prop="areaCode">
                                        <el-cascader
                                            placeholder="请选择所属地区（可搜索）"
                                            v-model="editForm.areaCode"
                                            :options="areaValue"
                                            :props="props"
                                             disabled 
                                            ref="cascaderAddr"
                                            @change="handleAreaChange"
                                            filterable style="width:100%">
                                        </el-cascader>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8" class="item">
                                    <el-form-item label="详细地址" required prop="address" >
                                        <el-input v-model="editForm.address" disabled  placeholder="请选择详细地址" class="address"></el-input>
                                    </el-form-item>
                                </el-col>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="头像" required class="headImg">
                                        <el-upload
                                            ref="headImg"
                                            class="upload-demo"
                                            :action="uploadUrl"
                                            list-type="picture-card"
                                            :data='uploadData'
                                             disabled 
                                            :show-file-list="false"
                                            :on-success="handleImgSuccess"
                                            style="width:100%">
                                            <el-image v-if="editForm.headImg" :src="editForm.headImg" fit="cover" style="border-radius: 5px;" class="avatar"></el-image>
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="状态" >
                                        <el-select v-model="editForm.status"  disabled  style="width:100%">
                                            <el-option
                                                    v-for="(item,i) in statusValue"
                                                    :key="i"
                                                    :label="item"
                                                    :value="i">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-card>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>紧急联系人</span>
                                </div>
                                <el-col :span="6" class="item">
                                    <el-form-item label="联系人" required prop="urgencyContact">
                                        <el-input v-model="editForm.urgencyContact" disabled  placeholder="请输入联系人"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="紧急电话" required prop="urgencyPhone">
                                        <el-input v-model="editForm.urgencyPhone" disabled  maxlength="11" placeholder="请输入紧急电话"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="联系人1">
                                        <el-input v-model="editForm.urgencyContact1" disabled  placeholder="请输入联系人"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="紧急电话1">
                                        <el-input v-model="editForm.urgencyPhone1" disabled  maxlength="11" placeholder="请输入紧急电话"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-card>
                            <el-image-viewer
                                v-if="imgDialog"
                                :on-close="imgClose"
                                :url-list="srcList" />
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>证件上传</span>
                                </div>
                                <el-row>
                                <el-col :span="6" class="item">
                                    <el-form-item label="身份证正面">
                                        <el-upload
                                            class="upload-demo"
                                            :action="uploadUrl"
                                            list-type="picture-card"
                                            :data='uploadData'
                                             disabled 
                                            :show-file-list="false"
                                            :on-success="idCardFrontSuccess"
                                            style="width:100%">
                                            <el-image v-if="editForm.idCardFront" :src="editForm.idCardFront" fit="cover" style="border-radius: 5px;" class="avatarImg"></el-image>
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <div class="uploadButton" v-if="editForm.idCardFront">
                                            <el-button type="primary" size="small" @click="imgPreview(editForm.idCardFront)">预览</el-button>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="身份证反面">
                                        <el-upload
                                            class="upload-demo"
                                            :action="uploadUrl"
                                            list-type="picture-card"
                                            :data='uploadData'
                                             disabled 
                                            :show-file-list="false"
                                            :on-success="idCardContrarySuccess"
                                            style="width:100%">
                                            <el-image v-if="editForm.idCardContrary" :src="editForm.idCardContrary" fit="cover" style="border-radius: 5px;" class="avatarImg"></el-image>
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <div class="uploadButton" v-if="editForm.idCardContrary">
                                            <el-button type="primary" size="small" @click="imgPreview(editForm.idCardContrary)">预览</el-button>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                </el-row>
                            </el-card>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>健康状况</span>
                                </div>
                                <el-col :span="6" class="item">
                                    <el-form-item label="血型" prop="bloodType">
                                        <el-select v-model="editForm.bloodType"  disabled placeholder="请选择血型" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.bloodType"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="残疾情况" prop="disabilityStatus">
                                        <el-select v-model="editForm.disabilityStatus"  disabled  placeholder="请选择残疾情况" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.disabilityType"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="过敏药物" prop="irritabilityMedicine">
                                        <el-input v-model="editForm.irritabilityMedicine" disabled  placeholder="请输入过敏药物"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="医疗保障情况" prop="medicalSecurityStatus">
                                        <el-select v-model="editForm.medicalSecurityStatus" disabled  placeholder="请选择医疗保障情况" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.medicalSecurity"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="主要疾病" prop="illness">
                                        <el-input v-model="editForm.illness" disabled  placeholder="请输入主要疾病"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="是否手术" prop="isOperation">
                                        <el-select v-model="editForm.isOperation" disabled  placeholder="请选择是否手术" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.status"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item"  v-if="editForm.isOperation===1">
                                    <el-form-item label="手术原因" required prop="operationCause">
                                        <el-input v-model="editForm.operationCause" disabled  placeholder="请输入手术原因"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item" v-if="editForm.isOperation===1">
                                    <el-form-item label="手术时间" required prop="operationTime">
                                        <el-date-picker
                                            v-model="editForm.operationTime"
                                            type="date"
                                             disabled 
                                            placeholder="请选择手术日期"
                                            :picker-options="pickerOptions0"
                                            style="width:100%">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-card>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>生活方式</span>
                                </div>
                                <el-col :span="6" class="item">
                                    <el-form-item label="饮食习惯"  prop="dietaryHabit">
                                        <el-select v-model="editForm.dietaryHabit"  disabled placeholder="请选择饮食习惯" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.dietHabits"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="忌食"  prop="diet">
                                        <el-input v-model="editForm.diet" disabled  placeholder="请输入忌食"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="吸烟状况" prop="smokeStatus">
                                        <el-select v-model="editForm.smokeStatus" disabled  placeholder="请选择吸烟状况" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.smokeType"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" class="item">
                                    <el-form-item label="饮酒频率" prop="drinkStatus">
                                        <el-select v-model="editForm.drinkStatus" disabled  placeholder="请选择饮酒频率" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.drinkType"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-card>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>经济状况</span>
                                </div>
                                <el-col :span="6" class="item">
                                    <el-form-item label="经济来源"  prop="pocketbook">
                                        <el-select v-model="editForm.pocketbook" disabled  placeholder="请选择经济来源" style="width:100%">
                                            <el-option
                                                    v-for="item in elderlyAllType.economicSources"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-card>
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>亲属信息</span>
                                    <el-button style="float: right;transform: translate(-19px, -9px);" disabled  type="primary" @click="showForm">添加亲属</el-button>
                                </div>
                                <el-col :span="24" class="item">
                                    <el-table
                                        :data="relativesInfo"
                                        style="width: 100%" border>
                                        <el-table-column
                                            prop="name"
                                            label="亲属姓名">
                                        </el-table-column>
                                        <el-table-column
                                            prop="phone"
                                            label="联系电话">
                                        </el-table-column>
                                        <el-table-column
                                            prop="relation"
                                            :formatter="relations"
                                            label="与老人关系">
                                        </el-table-column>
                                        <el-table-column
                                            prop="workUnit"
                                            label="工作单位">
                                        </el-table-column>
                                        <el-table-column
                                            prop="address"
                                            label="地址">
                                        </el-table-column>
                                        <el-table-column fixed="right" label="操作" width="120">
                                            <template slot-scope="scope">
                                                <el-button type="primary" size="small" @click.native.prevent="deleteRow(scope.$index, relativesInfo)">删除</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-col>
                            </el-card>
                        </el-row>
                    </div>

                </el-form>
            </div>
            <div class="modal-footer">
                <!-- <el-button :loading="loading" type="primary" @click="confirm('editForm')">保存</el-button> -->
                <el-button type="success" @click="closeSelf">关闭</el-button>
            </div>
        </div>
        <RelativesAdd ref="relativesEdit" v-show="relativeShow"  v-on:close="relativeShow=false" v-on:relativeConfirm="relativeConfirm"></RelativesAdd>
    </div>
        
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import RelativesAdd from "./RelativesAdd";
    import elderly from "@/common/status";
    import rules from "@/common/rules";
    import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
    const validatorIdNumber = (rule, value, callback) => {
        if (rules(value)) {
            callback();
        } else {
            return callback(new Error('请输入正确的证件号'))
        }
    };
    export default {
        name: 'Edit',
        props: ['nationValue',"areaValue"],
        data() {
            return {

                loading: false,
                idCardFrontDialog: false,
                idCardContraryDialog: false,
                imgDialog: false,
                dialogIdCardValue: '',
                srcList:[],
                thsArea: '',
                uploadUrl:this.$institutionUrl+'Upload/Imgs',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                relativeLoading: false,
                relativeShow:false,
                baiduMapShow:false,
                props: {
                    emitPath:false,
                    value: 'areaCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listAreaDTO'
                },
                //时间范围限制
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - 8.64e6
                    }
                },  
                pickerOptions1: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e6
                    }
                },  
                statusValue:['正常','禁用'],
                relativesInfo:[],
                parentAreaCode:'00000000-0000-0000-0000-000000000000',
                editForm:{
                    timeStr:timeStr,
                    sign:null,
                    phone:null,
                    elderlyCode:null,
                    isMarriage:null,
                    dietaryHabit:null,
                    isOperation:null,
                    areaCode:null,
                    kinsfolk:null,
                    bloodType:null,
                    staffCode:getStaffCode(),
                    name:null,
                    idCard:null,
                    operationCause:'',
                    sysNation:null,
                    urgencyContact:null,
                    urgencyPhone:null,
                    urgencyContact1:null,
                    urgencyPhone1:null,
                    drinkStatus:null,
                    politicsStatus:null,
                    medicalSecurityStatus:null,
                    illness:'',
                    pocketbook:null,
                    diet:'',
                    disabilityStatus:null,
                    irritabilityMedicine:'',
                    education:null,
                    smokeStatus:null,
                    headImg:null,
                    address:null,
                    operationTime:'',
                    idCardFront:null,
                    idCardContrary:null,
                },
                bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',
                goodslist:'',
                elderlyAllType:elderly
            }
        },
       watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.bodyStyle = "height:"+(val+50)+'px';
            },
        },
       components:{
            RelativesAdd,ElImageViewer
        },
        methods: {
            init(row){
                this.elderlyAllType.rules.idCard.push({ required: true,validator: validatorIdNumber, trigger: 'blur' })
                this.$refs.editForm.resetFields();
                this.srcList=[]
                this.loading = false
                this.editForm.elderlyCode = row.elderlyCode;
                this.editForm.name = row.name;
                if(row.idCardFront){
                    this.editForm.idCardFront = this.$imgUrl+row.idCardFront;
                    this.srcList.push(this.editForm.idCardFront)
                }else{
                    this.editForm.idCardFront =null
                }
                if(row.idCardContrary){
                    this.editForm.idCardContrary = this.$imgUrl+row.idCardContrary;
                    this.srcList.push(this.editForm.idCardContrary)
                }
                else{
                    this.editForm.idCardContrary =null
                }
                if(row.headImg){
                    this.editForm.headImg =  this.$imgUrl+row.headImg;
                }else{
                    this.editForm.headImg =null
                }
                if(row.areaCode){
                    this.editForm.areaCode = '';
                }
                this.editForm.idCard = row.idCard;
                this.editForm.operationCause = row.operationCause;
                if(row.operationTime){
                    this.editForm.operationTime = row.operationTime;
                }
                this.editForm.illness = row.illness;
                this.editForm.phone = row.phone;
                this.editForm.areaCode = row.areaCode;
                this.editForm.urgencyContact = row.urgencyContact;
                this.editForm.urgencyPhone = row.urgencyPhone;
                this.editForm.urgencyContact1 = row.urgencyContact1;
                this.editForm.urgencyPhone1 = row.urgencyPhone1;
                if(row.kinsfolk){
                    this.editForm.kinsfolk = JSON.parse(row.kinsfolk);
                    this.relativesInfo=this.editForm.kinsfolk
                }else{
                    this.relativesInfo=[]
                }
                this.editForm.diet = row.diet;
                this.editForm.irritabilityMedicine = row.irritabilityMedicine;
                this.editForm.address = row.address;
                this.editForm.status = row.status;
                this.editForm.isMarriage = this.isSelectTwo(row.isMarriage);
                this.editForm.sysNation = this.isSelectTwo(row.sysNation);
                this.editForm.politicsStatus = this.isSelectTwo(row.politicsStatus);
                this.editForm.censusRegister = this.isSelectTwo(row.censusRegister);
                this.editForm.education = this.isSelectTwo(row.education);
                this.editForm.bloodType=this.isSelectTwo(row.bloodType)
                this.editForm.disabilityStatus=this.isSelectTwo(row.disabilityStatus)
                this.editForm.medicalSecurityStatus=this.isSelectTwo(row.medicalSecurityStatus)
                this.editForm.isOperation=this.isSelectTwo(row.isOperation)
                this.editForm.dietaryHabit=this.isSelectTwo(row.dietaryHabit)
                this.editForm.smokeStatus=this.isSelectTwo(row.smokeStatus)
                this.editForm.drinkStatus=this.isSelectTwo(row.drinkStatus)
                this.editForm.pocketbook=this.isSelectTwo(row.pocketbook)
                var appNav=document.getElementsByClassName('app-nav');
                this.goodslist="left:"+appNav[0].scrollWidth+'px'
            },
            
            closeSelf() {
                this.$emit("closeInfo");
            },
            handleAreaChange(){
                var thsAreaCode = this.$refs.cascaderAddr.getCheckedNodes()
                this.thsArea=thsAreaCode[0].parent.label
            },
            openBaiduMap(){
                if(!this.editForm.areaCode){
                    this.$message({type: 'info', message: '请选择地区'});
                    return;
                }
                this.$refs.baiduMap.init(this.thsArea);
                this.baiduMapShow=true;
            },
            colseMap(){
                this.baiduMapShow=false
            },
            handleImgSuccess(res, file) {
                 console.log(file)
                this.editForm.headImg = this.$imgUrl+res.data.path;
            },
            idCardFrontSuccess(res) {
                this.editForm.idCardFront = this.$imgUrl+res.data.path;
            },
            idCardContrarySuccess(res) {
                this.editForm.idCardContrary = this.$imgUrl+res.data.path;
            },
            idCardFrontPreview() {
                this.idCardFrontDialog = true;
            },
            idCardFrontRemove() {
                this.editForm.idCardFront = '';
            },
            idCardContraryPreview() {this.idCardContraryDialog = true;},
            idCardContraryRemove() {this.editForm.idCardContrary = '';},
            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        this.$message({type: 'warning', message: '请完善信息'});
                        return false;
                    }
                })

            },
            imgPreview(url){
                this.srcList=this.getPreviewList(url)
            },
            imgClose() {this.imgDialog = false;},
            getPreviewList(url){
                this.imgDialog = true;
                var list=[]
                var list1=this.srcList;
                for(var i in list1){
                    if(list1[i]==url){
                        var str =list1.slice(i)
                        list=str.concat(list)
                        return list
                    }else{
                        list.push(list1[i])
                    }
                }
            },
            showForm(){
                this.relativeShow=!this.relativeShow;
                this.$refs.relativesEdit.init()
            },
            relativeConfirm(relativeForm){
                console.log(relativeForm)
                this.relativesInfo.push(relativeForm);
            },
            deleteRow(index, rows) {
                rows.splice(index, 1);
            },
            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                if(this.editForm.headImg==null){
                    this.$message({type: 'info', message: '请上传头像'});
                    this.loading = false;
                    return;
                }
                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.editForm.kinsfolk =JSON.stringify(this.relativesInfo);
                this.editForm.bloodType=this.isSelect(this.editForm.bloodType)
                this.editForm.disabilityStatus=this.isSelect(this.editForm.disabilityStatus)
                this.editForm.medicalSecurityStatus=this.isSelect(this.editForm.medicalSecurityStatus)
                this.editForm.isOperation=this.isSelect(this.editForm.isOperation)
                this.editForm.dietaryHabit=this.isSelect(this.editForm.dietaryHabit)
                this.editForm.smokeStatus=this.isSelect(this.editForm.smokeStatus)
                this.editForm.drinkStatus=this.isSelect(this.editForm.drinkStatus)
                this.editForm.pocketbook=this.isSelect(this.editForm.pocketbook)
                this.editForm.isMarriage=this.isSelect(this.editForm.isMarriage)
                this.editForm.politicsStatus=this.isSelect(this.editForm.politicsStatus)
                this.editForm.education=this.isSelect(this.editForm.education)
                this.editForm.censusRegister=this.isSelect(this.editForm.censusRegister)
                this.editForm.headImg =this.editForm.headImg.replace(this.$imgUrl,'')
                this.editForm.idCardFront=this.editForm.idCardFront.replace(this.$imgUrl,'')
                this.editForm.idCardContrary=this.editForm.idCardContrary.replace(this.$imgUrl,'')
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Elderly/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            isSelect(data){
                if(data==null){
                    return 0
                }else{
                    return data
                }
            },
            isSelectTwo(data){
                if(data==0){
                    return null
                }else{
                    return data
                }
            },
            relations(row){
                return this.allStatus(row.relation,elderly.relationship);
            },
            allStatus(row,status){
                for(var i in status){
                    if(status[i].value==row){
                        return status[i].label
                    }
                }
                return "其它";
            }


        }
    }


</script>



<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 200px;
        background-color: rgba(0,0,0,.3);
        display: flex;
        // justify-content: center;
        // align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  none;
            border-radius: 0;
            // overflow-x:auto;
            // display: flex;
            // flex-direction: column;
            // border-radius: 10px;
            width: 100%;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .add_title{
                margin-left: 20px;
                font-size: 16px;
            }
            .modal-body .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }
            .modal-body .avatar-uploader .el-upload:hover {
                border-color: #409EFF;
            }
            .modal-body .headImg .avatar-uploader-icon {
                font-size: 20px;
                color: #8c939d;
                width: 250px;
                height: 250px;
                line-height: 250px;
                text-align: center;
            }
            .modal-body .avatar-uploader-icon {
                font-size: 20px;
                color: #8c939d;
                width: 180px;
                height: 180px;
                line-height: 180px;
                text-align: center;
            }
            .modal-body .avatar-uploader-icon {
                font-size: 20px;
                color: #8c939d;
                width: 180px;
                height: 180px;
                line-height: 180px;
                text-align: center;
            }
            .modal-body .avatar {
                width: 250px;
                height: 250px;
                display: block;
            }
            .modal-body .headImg  /deep/ .el-upload--picture-card{
                width:250px;
                height: 250px;
                line-height: 250px;
            }
            .modal-body  /deep/ .el-upload--picture-card{
                width:100%;
                height: 180px;
                line-height: 180px;
            }
            .modal-body  .avatarImg{
                width:100%;
                height: 180px;
                line-height: 180px;
            }
            .upload-demo{
                margin-top: 40px;
            }
            .modal-body /deep/ .el-divider{
                margin: 10px 0px 0px;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-body /deep/ .el-input.is-disabled .el-input__inner {
                color: #000;
            }
            .modal-body /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
                border-color: #fff; 
            }
            .modal-body /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
                background-color: #409EFF;
                border-color: #409EFF
            }
            .modal-body /deep/ .el-checkbox__input.is-disabled+span.el-checkbox__label {
                 color:#606266; 
            }
            .address  /deep/ .el-input__inner{
                background: #fff;
            }
            .modal-body {
                position: relative;
                padding: 0px 0px 20px;
                z-index: 99;
                overflow-y:scroll;
                height:500px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
                .el-button{
                    width: 15%;
                }
            }
            .uploadButton{
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 10px 0 0;
                display: flex;
                 .el-button{
                    width: 35%;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
